import { IVirtualDialogue, VirtualDialogueSource, VirtualDialogueStatus } from '../model/virtual-dialogue.model'

export class AICandidateEvaluationUtil {
  static isUnreviewedAIDraftDialogue(dialogue: IVirtualDialogue): boolean {
    return dialogue?.source === VirtualDialogueSource.AI && dialogue?.status === VirtualDialogueStatus.Draft && !dialogue?.edited_by_human
  }
}
